import axiosInstance from './axiosConfig';

// ─── Dummy fallbacks (shown when API returns empty) ───────────────────────────

const DUMMY_SERVED_COMPANIES = [
  { id: 1, companyName: "Reliance Retail", logo: null },
  { id: 2, companyName: "Tata Cliq", logo: null },
  { id: 3, companyName: "Meesho", logo: null },
  { id: 4, companyName: "Myntra", logo: null },
  { id: 5, companyName: "Nykaa", logo: null },
  { id: 6, companyName: "Ajio", logo: null },
  { id: 7, companyName: "Snapdeal", logo: null },
  { id: 8, companyName: "Flipkart", logo: null },
  { id: 9, companyName: "Amazon Sellers", logo: null },
  { id: 10, companyName: "Urban Company", logo: null },
  { id: 11, companyName: "Boat Lifestyle", logo: null },
  { id: 12, companyName: "Lenskart", logo: null },
];

const DUMMY_STATS = [
  { value: "200", label: "Brands & Agencies" },
  { value: "15M", label: "Orders Processed" },
  { value: "20", label: "Saved Time" },
  { value: "40", label: "Growth %" },
  { value: "₹50", label: "Ad Spend Managed" },
];

// ─── API: Fetch "We Have Served" companies (logo + companyName) ───────────────
// TODO: Replace with real endpoint once backend creates it
// Expected response: [{ id, companyName, logo }, ...]
export const fetchWeHaveServedCompanies = async () => {
  try {
    const response = await axiosInstance.get('/we_have_served_companies');
    const data = response?.data;
    return Array.isArray(data) && data.length > 0 ? data : DUMMY_SERVED_COMPANIES;
  } catch (_err) {
    // API not ready yet — return dummy data silently
    return DUMMY_SERVED_COMPANIES;
  }
};

// ─── API: Fetch landing page stats (value + label) ────────────────────────────
// TODO: Replace with real endpoint once backend creates it
// Expected response: [{ value, label }, ...]
export const fetchLandingStats = async () => {
  try {
    const response = await axiosInstance.get('/we_have_served_companies/stats');
    const data = response?.data;
    
    // If the backend returns a Hash object, format it into the expected array
    if (data && !Array.isArray(data) && Object.keys(data).length > 0) {
      return [
        { value: `${data.brands_agencies || 0}+`, label: "Brands & Agencies" },
        { value: `${data.avg_roas_improvement || 0}+`, label: "Orders Processed" },
        { value: `${data.saved_weekly_hrs || 0}hrs`, label: "Saved Time" },
        { value: `${data.growth_rate || 0}%`, label: "Growth " },
        { value: `₹${data.ad_spend_managed || 0}Cr+`, label: "Ad Spend Managed" },
      ];
    }

    return Array.isArray(data) && data.length > 0 ? data : DUMMY_STATS;
  } catch (_err) {
    // API not ready yet — return dummy data silently
    return DUMMY_STATS;
  }
};
